<div class="page-inner-view">
  <table class="page-inner-table" *ngIf="tasks_data">
    <thead>
      <tr>
        <!-- <th appColumnResizable>Actions</th> -->
        <th>Actions</th>
        <!-- <th appColumnResizable>Sub Tasks</th> -->
        <!-- <th appColumnResizable>Task Name</th> -->
        <th>Task Name</th>
        <!-- <th appColumnResizable>Due Date</th> -->
        <th>Due Date</th>
        <!-- <th appColumnResizable>Actual Date</th> -->
        <th>Actual Date</th>
        <!-- <th appColumnResizable>Owner</th> -->
        <!-- <th appColumnResizable>Status</th> -->
        <th>Status</th>
        <!-- <th appColumnResizable>Type</th> -->
        <th>Type</th>
        <!-- <th appColumnResizable>Communication Channel</th> -->
        <th>Communication Channel</th>
        <!-- <th appColumnResizable>Description</th> -->
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let activity of tasks_data; let index = index">
        <tr>
          <td>
            <img
              src="assets/edit-client.png"
              class="page-table-actions"
              (click)="openActivityOperationModal(activity, 'Edit', index)"
            />
            <!-- Remove Delete <img
              src="assets/delete-icon.png"
              class="page-table-actions"
              class="page-table-actions"
              (click)="removeActivity(activity, index)"
            /> -->
            <!-- <img src="assets/comments-doc.png" class="page-table-actions" (click)="openCommentsModal(activity)" /> -->
          </td>
          <!-- <td>
            <img
              src="assets/ic-activities.png"
              class="client-table-icon"
              (click)="toggleSubTasksView(index)"
            />
          </td> -->
          <td [matTooltip]="activity.name">{{ activity.name }}</td>
          <td>{{ activity.due_date | date: "dd-MMM-yyyy" }}</td>
          <td>{{ activity.actual_date | date: "dd-MMM-yyyy" }}</td>
          <!-- <td><span>{{activity.task_owner}}</span></td> -->
          <td [matTooltip]="activity.status_name">
            <span
              [ngClass]="{
                'activity-status-pending': activity.status_name == 'Pending',
                'activity-status-progress':
                  activity.status_name == 'In Progress',
                'activity-status-completed': activity.status_name == 'Completed'
              }"
              >{{ activity.status_name }}</span
            >
          </td>
          <td>
            <span
              *ngIf="
                activity.email_template != null && activity.email_template != ''
              "
              >Automated Task</span
            >
            <span
              *ngIf="
                activity.email_template == null || activity.email_template == ''
              "
              >Manual Task</span
            >
          </td>
          <td [matTooltip]="activity.communication_type_name">
            {{ activity.communication_type_name }}
          </td>
          <!-- <td [matTooltip]="activity.description">{{activity.description}}</td> -->
          <td [innerHTML]="activity.description"></td>
        </tr>
        <tr *ngIf="show_sub_tasks == index">
          <td colspan="9">
            <app-initiative-milestone-sub-tasks
              [initiative_data]="initiative_data"
              [milestone_data]="milestone"
              [parent_task_data]="activity"
              [filters_data]="filters_data"
            ></app-initiative-milestone-sub-tasks>
          </td>
        </tr>
      </ng-container>
      <tr>
        <td colspan="10">
          <span
            class="page-table-actions"
            (click)="
              openActivityOperationModal(selected_activity_data, 'Add', null)
            "
            >+ Add New Task</span
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #activitiesOperationsModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>{{ activity_operation_type }} Task</span>
      <span
        class="page-modal-close-icon"
        (click)="closeActivityOperationModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Task Name</p>
        <!-- <input
          type="text"
          class="page-modal-input"
          [(ngModel)]="selected_activity_data.name"
        /> -->
        <mat-select
          class="page-modal-input"
          [(ngModel)]="selected_activity_data.name"
        >
          <mat-option [value]="''">Select Task Name</mat-option>
          <mat-option
            *ngFor="let task_name of task_names_list"
            [value]="task_name.name"
            >{{ task_name.name }}</mat-option
          >
        </mat-select>
        <p
          class="page-modal-input-error"
          *ngIf="selected_activity_data_errors.name"
        >
          Task Name is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Description</p>
        <!-- <input type="text" class="page-modal-input" [(ngModel)]="selected_activity_data.description" /> -->
        <!-- <textarea class="page-modal-input page-modal-textarea" [(ngModel)]="selected_activity_data.description"></textarea> -->
        <app-textarea-tagging
          [value]="selected_activity_data.description"
          [users]="tagging_users_list"
          [placeholder]="'Description ...'"
          (valueChanged)="selected_activity_data.description = $event"
        ></app-textarea-tagging>
        <p
          class="page-modal-input-error"
          *ngIf="selected_activity_data_errors.description"
        >
          Description is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Due date</p>
        <input
          type="text"
          class="page-modal-input"
          bsDatepicker
          [(ngModel)]="selected_activity_data.due_date"
          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p
          class="page-modal-input-error"
          *ngIf="selected_activity_data_errors.scheduled_date"
        >
          Due date is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Actual date</p>
        <input
          type="text"
          class="page-modal-input"
          bsDatepicker
          [(ngModel)]="selected_activity_data.actual_date"
          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p
          class="page-modal-input-error"
          *ngIf="selected_activity_data_errors.actual_date"
        >
          Actual date is Required.
        </p>
      </div>
      <!-- <div class="page-modal-input-section">
          <p class="page-modal-input-label">Description</p>
          <textarea class="page-modal-input page-modal-textarea" [(ngModel)]="shortlist_data.description"></textarea>
          <p class="page-modal-input-error" *ngIf="shortlist_data_errors.description">Description is Required.</p>
        </div> -->
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Communication Channel</p>
        <mat-select
          class="page-modal-input"
          [(ngModel)]="selected_activity_data.communication_type"
        >
          <mat-option [value]="''">Select Communication Channel</mat-option>
          <mat-option
            *ngFor="let communication of communication_type_list"
            [value]="communication.id"
            >{{ communication.name }}</mat-option
          >
        </mat-select>
        <p
          class="page-modal-input-error"
          *ngIf="selected_activity_data_errors.communication_type"
        >
          Communication Channel is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Status</p>
        <mat-select
          class="page-modal-input"
          [(ngModel)]="selected_activity_data.status"
        >
          <mat-option [value]="''">Select Status</mat-option>
          <mat-option *ngFor="let status of status_list" [value]="status.id">{{
            status.name
          }}</mat-option>
        </mat-select>
        <p
          class="page-modal-input-error"
          *ngIf="selected_activity_data_errors.status"
        >
          Status is Required.
        </p>
      </div>
      <div
        class="page-modal-heading-section"
        *ngIf="activity_operation_type != 'Add'"
      >
        <span>Add Comments</span>
      </div>
      <div
        class="page-modal-input-section"
        *ngIf="activity_operation_type != 'Add'"
      >
        <p class="page-modal-input-label">Date</p>
        <input
          type="text"
          class="page-modal-input"
          bsDatepicker
          [(ngModel)]="comment_data.comment_date"
          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p
          class="page-modal-input-error"
          *ngIf="comment_data_errors.comment_date"
        >
          Schedule date is Required.
        </p>
      </div>
      <div
        class="page-modal-input-section"
        *ngIf="activity_operation_type != 'Add'"
      >
        <p class="page-modal-input-label">Comments</p>
        <!-- <textarea class="page-modal-input page-modal-textarea" [(ngModel)]="comment_data.description"></textarea> -->
        <app-textarea-tagging
          [value]="comment_data.description"
          [users]="tagging_users_list"
          [placeholder]="'Comments ...'"
          (valueChanged)="comment_data.description = $event"
        ></app-textarea-tagging>
        <p
          class="page-modal-input-error"
          *ngIf="comment_data_errors.description"
        >
          Description is Required.
        </p>
      </div>
      <div
        class="page-modal-input-section"
        *ngIf="
          activity_operation_type != 'Add' &&
          selected_activity_data.comments.length > 0
        "
      >
        <div class="page-modal-heading-section">
          <span>Comments</span>
        </div>
        <table class="comments-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Comments</th>
              <!-- Remove Delete <th>Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let comment of selected_activity_data.comments;
                let index = index
              "
            >
              <td>{{ comment.comment_date | date: "dd-MMM-yyyy" }}</td>
              <!-- <td>{{ comment.description }}</td> -->
              <td [innerHTML]="comment.description"></td>
              <!-- Remove Delete <td>
                <img
                  src="assets/delete-icon.png"
                  class="page-table-actions"
                  class="page-table-actions"
                  (click)="
                    deleteComment(
                      selected_activity_data.comments,
                      comment,
                      index
                    )
                  "
                />
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="saveTask()">
        Save
      </button>
      <button
        class="page-modal-secondary-button"
        (click)="closeActivityOperationModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #activitiesDeleteModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>Delete Activity Details</span>
      <span class="page-modal-close-icon" (click)="closeDeleteActivityModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <p class="page-modal-delete-description">
        Are you sure you want to delete?
      </p>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="deleteActivity()">
        Yes
      </button>
      <button
        class="page-modal-secondary-button"
        (click)="closeDeleteActivityModal()"
      >
        No
      </button>
    </div>
  </div>
</ng-template>

<ng-template #commentsModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>Comments</span>
      <span class="page-modal-close-icon" (click)="closeCommentsModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <div
        class="page-modal-input-section"
        *ngIf="selected_activity_data.comments.length > 0"
      >
        <table class="comments-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Comments</th>
              <!-- <th>Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let comment of selected_activity_data.comments;
                let index = index
              "
            >
              <td>{{ comment.comment_date | date: "dd-MMM-yyyy" }}</td>
              <td>{{ comment.description }}</td>
              <!-- Remove Delete <td>
                <img
                  src="assets/delete-icon.png"
                  class="page-table-actions"
                  class="page-table-actions"
                  (click)="
                    deleteComment(
                      selected_activity_data.comments,
                      comment,
                      index
                    )
                  "
                />
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page-modal-heading-section">
        <span>Add Comments</span>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Date</p>
        <input
          type="text"
          class="page-modal-input"
          bsDatepicker
          [(ngModel)]="comment_data.comment_date"
          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p
          class="page-modal-input-error"
          *ngIf="comment_data_errors.comment_date"
        >
          Schedule date is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Comments</p>
        <textarea
          class="page-modal-input page-modal-textarea"
          [(ngModel)]="comment_data.description"
        ></textarea>
        <p
          class="page-modal-input-error"
          *ngIf="comment_data_errors.description"
        >
          Description is Required.
        </p>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="saveComment()">
        Save
      </button>
      <button
        class="page-modal-secondary-button"
        (click)="closeCommentsModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>
